import { firstError } from '@src/utils/errorMessageUtils';
import React from 'react';

interface FieldErrorMessageProps {
  errors: string[];
}

const FieldErrorMessage: React.FC<FieldErrorMessageProps> = ({ errors = [] }) => {
  return (
    <div data-testid='error-message'>
      <p className='text-xs text-warning-500'>{firstError(errors)}</p>
    </div>
  );
};

export default FieldErrorMessage;
